import { useMemo } from 'react';
import type React from 'react';

import { SHARE_BUTTON_CONFIG } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { SharePetitionButton } from './components/SharePetitionButton';
import { useShareSocial } from './hooks/useShareSocial';
import type { SupportedChannelShareAction } from './types';

type ShareSocialProps = {
	className?: string;
};

export const ShareSocial: React.FC<ShareSocialProps> = ({ className }) => {
	const actions = useShareSocial();

	return (
		<div className={className}>
			{actions.map((action) => (
				<Button key={action.channel} action={action} />
			))}
		</div>
	);
};

const Button: React.FC<{ action: SupportedChannelShareAction }> = ({ action }) => {
	const { channel } = action;

	const { label, successLabel } = SHARE_BUTTON_CONFIG[channel];

	const buttonConfig = useMemo(
		() => ({
			...action,
			label,
			successLabel,
		}),
		[action, label, successLabel],
	);

	return (
		<div
			data-testid={`share-social-${channel.toLowerCase()}`}
			key={channel}
			className="sm:w-1/4 [@media(min-width:1204px)]:flex-1 [@media(min-width:1204px)]:justify-items-center"
		>
			<SharePetitionButton data-qa={`share-social-${channel.toLowerCase()}`} buttonConfig={buttonConfig} />
		</div>
	);
};
